import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Link from 'redux-first-router-link';
import { prefix } from '../../utils/string';
import { addEvent, removeEvent, addClass, removeClass, offset } from '../../utils/dom';
import { openCart, openMenu } from '../../actions/environment';
import s from './Logo.scss';

class Logo extends Component {
	constructor(props) {
		/* Called before mounting. Initialize state */
		super(props);

		this.state = {
			headerHeight: null,
		};
	}

	componentDidMount() {
		const { headerElement, cartIsOpen, menuIsOpen } = this.props;

		const $html = document.querySelector('html');
		const logoAspectRatio = 0.168553459;
		let headerHeight = (document.body.clientWidth - 40) * logoAspectRatio;
		let menuOffset = offset(headerElement.current).top + headerHeight;

		let isScrolled = false;
		let headerIsFixed = false;
		let firstScroll = true;

		const resizeEvent = () => {
			headerHeight = (document.body.clientWidth - 40) * logoAspectRatio;
			menuOffset = offset(headerElement.current).top + (firstScroll ? headerHeight : 0);
			this.setState({
				headerHeight: firstScroll ? 0 : headerHeight,
			});
		};

		addEvent(window, 'resize.logoHeader', () => {
			window.requestAnimationFrame(resizeEvent);
		});

		const scrollEvent = () => {
			const top = window.pageYOffset || document.documentElement.scrollTop;
			menuOffset = offset(headerElement.current).top + (firstScroll ? headerHeight : 0);

			if (cartIsOpen === 1) this.props.openCart(false);
			if (menuIsOpen) this.props.openMenu();

			// make logo sticky when level with header.
			if (firstScroll && top > offset(headerElement.current).top && top < menuOffset - (headerHeight / 2)) {
				const logoScrolled = top - offset(headerElement.current).top;
				this.setState({
					headerHeight: logoScrolled,
				});
			} else if (firstScroll && top >= menuOffset - (headerHeight / 2)) {
				headerIsFixed = true;
				addClass($html, 'headerIsFixed');
				addClass($html, 'headerIsMinimized');

				const logoScrolled = top - offset(headerElement.current).top;
				if (logoScrolled < headerHeight) {
					this.setState({
						headerHeight: logoScrolled,
					});
				} else {
					firstScroll = false;
					this.setState({
						headerHeight,
					});
				}
			} else if (!headerIsFixed && top >= menuOffset) {
				headerIsFixed = true;
				addClass($html, 'headerIsFixed');
			} else if (headerIsFixed && top < menuOffset) {
				headerIsFixed = false;
				removeClass($html, 'headerIsFixed');
			}

			if (top > 0 && !isScrolled) {
				addClass($html, 'is-scrolled');
				isScrolled = true;
			} else if (top === 0) {
				removeClass($html, 'is-scrolled');
				isScrolled = false;
			}
		};

		addEvent(window, 'scroll.logoHeader', () => {
			window.requestAnimationFrame(scrollEvent);
		});

		resizeEvent();
		scrollEvent();
	}

	componentWillUnmount() {
		removeEvent(window, 'scroll.logoHeader');
		removeEvent(window, 'resize.logoHeader');
	}

	render() {
		const { setup } = this.props;
		const { headerHeight } = this.state;

		return (
			<Link className={[s.logo].join(' ')} to={prefix(setup, '')}>
				<svg xmlns="http://www.w3.org/2000/svg" width="795" height="134" viewBox="0 0 795 134" aria-labelledby="title" style={(headerHeight !== null ? { marginTop: `-${headerHeight}px` } : { marginTop: 0 })}>
					<title>APLACE logo</title>
					<g fill="none" fillRule="evenodd">
						<polyline fill="#000" fillRule="nonzero" points="724 126 724 19 790.591 19 790.591 38.619 744.697 38.619 744.697 63.067 780.387 63.067 780.387 81.63 744.697 81.63 744.697 106.38 795 106.38 795 126 724 126" />
						<path fill="#000" fillRule="nonzero" d="M666,38.670713 C660.791115,43.0922662 655.70649,47.4072159 650.570758,51.7650062 C645.419994,46.3342071 639.746137,41.9584835 632.637282,39.7267847 C613.270812,33.6473982 593.796116,45.8101564 590.846953,65.77589 C589.230575,76.7161954 590.567369,87.0447763 597.553969,96.0134157 C606.980668,108.116396 625.457278,111.561581 638.808177,103.862221 C640.995749,102.599916 643.128205,101.199126 645.109345,99.6389299 C647.014326,98.1365184 648.689827,96.3451816 650.663952,94.4960598 C655.702481,98.7920799 660.831199,103.166807 665.954906,107.535557 C651.29928,125.912201 628.215041,132.312395 603.968373,125.107196 C582.185854,118.634273 568.289816,99.1915938 568.006223,75.6920051 C567.67954,48.5360171 580.225758,28.5573317 603.070497,21.1907332 C626.332106,13.6886387 650.015598,19.3764816 666,38.670713" />
						<path fill="#000" fillRule="nonzero" d="M459.899279,82.5346539 L489.495812,82.5346539 L474.698046,42.0892475 L459.899279,82.5346539 Z M496.440764,101.55068 L452.954328,101.55068 L444.045672,126 L422,126 L463.0718,19 L487.230154,19 L528,126 L505.350419,126 L496.440764,101.55068 Z" />
						<polyline fill="#000" fillRule="nonzero" points="298 126 298 19 318.973 19 318.973 106.079 367 106.079 367 126 298 126" />
						<path fill="#000" fillRule="nonzero" d="M177.986649,38.4783769 C177.986649,49.3347173 177.986649,60.2331056 177.986649,71.5179332 C184.975561,71.2296054 191.778274,71.4438489 198.434618,70.5508338 C207.223779,69.3724944 212.092817,63.0853478 212.002207,54.3804529 C211.910602,45.704591 206.863331,39.5125524 198.022393,38.6105271 C191.450685,37.9407658 184.7575,38.4783769 177.986649,38.4783769 Z M177.748674,90.161125 C177.748674,102.634303 177.748674,114.736059 177.748674,127 C170.732878,127 163.944105,127 157,127 C157,91.0541401 157,55.2264145 157,19.2024658 C157.988743,19.1504066 158.858997,19.0653099 159.730246,19.0643088 C171.623046,19.0552985 183.519828,18.8841039 195.408645,19.1403953 C200.497736,19.2505204 205.699342,19.7300655 210.62414,20.9584619 C223.230866,24.1050386 231.604815,34.2545756 233.442902,47.6237725 C234.278306,53.699679 234.273327,59.7255287 232.74192,65.6853032 C229.146399,79.6691988 219.339619,86.5940703 205.894502,89.0458573 C201.581072,89.8327517 197.127246,89.9618985 192.728185,90.1210795 C187.878065,90.2972798 183.015997,90.161125 177.748674,90.161125 Z" />
						<path fill="#000" fillRule="nonzero" d="M37.9002792,82.5346539 L67.495812,82.5346539 L52.6990454,42.0892475 L37.9002792,82.5346539 Z M74.4417635,101.55068 L30.9543276,101.55068 L22.0456724,126 L0,126 L41.0718005,19 L65.2311538,19 L106,126 L83.3514187,126 L74.4417635,101.55068 Z" />
					</g>
				</svg>
			</Link>
		);
	}
}

const mapState = (state, props) => ({ ...props });

export default hot(module)(connect(mapState, { openCart, openMenu })(Logo));
